import {getUser as getCognitoUser, NoCurrentUserError, isRiaUser} from '@simpleinvest/front-end-auth';
import User from '@advisor/models/store/user/index';
// eslint-disable-next-line import/no-cycle
import AdvisorProxyApi from '@advisor/advisorProxyApi';
import RwAdvisorService from '@advisor/rwSdk/AdvisorService';
// eslint-disable-next-line no-warning-comments
// TODO: move to common util
import RWStorage from '@advisor/util/common/storage';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {getAzureToken, transformRiaUserData, validateToken} from '@advisor/config/useAuth';

const stateObj = () => new User();

const getters = {
  getUserProfile: (state) => state?.profile,
};

const actions = {
  // eslint-disable-next-line require-await
  async setBearer({commit}) {
    const tokenObj = RWStorage.getToken();

    // eslint-disable-next-line no-eq-null
    if (tokenObj == null || !tokenObj.user_id) {
      // eslint-disable-next-line no-console
      console.warn('user.setBearer', 'User not set');

      return;
    }

    commit('SET_BEARER', {
      ...tokenObj,
    });
  },
  // eslint-disable-next-line consistent-return
  async getUser({commit}) {
    let riaUserData = null;

    try {
      if (validateToken()) {
        riaUserData = await RwAdvisorService.updateNSKRiaUser(getAzureToken()?.idToken);
      }
    } catch (error) {
      exceptionHandler.handleGenericException('user.getUser', error);
    }
    const userDetails = riaUserData && transformRiaUserData(riaUserData);
    let user = userDetails || null;
    let riaUserId = userDetails?.userId || null;

    if (user === null) {
      try {
        user = await getCognitoUser();

        if (!(await isRiaUser())) {
          throw new Error('Invalid user');
        }

        riaUserId = user.userId;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('user.getUser', 'Cognito user not set');

        if (!(error instanceof NoCurrentUserError)) {
          throw error;
        }
      }
    }

    try {
      const userData = await RwAdvisorService.getRiaUserFromRiaUserId({
        riaUserId,
      }).catch((error) => {
        throw error;
      });

      // eslint-disable-next-line no-warning-comments
      // TODO: refactor to call SET_USER and SET_USER_PROFILE
      commit('SET_USER', {
        user,
        profile: userData,
      });

      // eslint-disable-next-line consistent-return
      return userData;
    } catch (error) {
      exceptionHandler.handleGenericException('user.getUser', error);
    }
  },

  // eslint-disable-next-line require-await
  async setUserProfile({commit}, profile) {
    commit('SET_USER_PROFILE', profile);
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateUserProfile({commit}, payload) {
    try {
      const response = await AdvisorProxyApi.saveRiaUser(payload);

      return response;
    } catch (error) {
      return exceptionHandler.handleGenericException('user.updateUserProfile', error);
    }
  },
};

const mutations = {
  SET_BEARER(state, user) {
    // RW token
    state.accessToken = user.access_token;
    state.expiresIn = user.expires_in;
    state.expiresAt = Date.now() + user.expires_in;
    state.refreshToken = user.refresh_token;
    state.id = user.user_id;
    state.riaId = user.ria_id;
    state.type = user.user_type;
    state.scope = user.scope;
  },

  SET_USER(state, user) {
    state.profile = user.profile;

    // eslint-disable-next-line no-warning-comments
    // TODO: refactor to use the Amplify's values wherever needed?
    state.id = user.user.userId;
    state.riaId = user.user.riaId;
    state.type = 'ria_user';
  },
  SET_USER_PROFILE(state, profile) {
    state.profile = profile;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
  modules: {},
};
